// src/firestoreServices.js
import { db } from "./firebaseConfig"; // شيلنا storage من هنا
import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  setDoc,
  getDoc,
  serverTimestamp,
} from "firebase/firestore";

// ==========================================
// ☁️ إعدادات Cloudinary
// ==========================================
const CLOUD_NAME = "defcamc5x"; // مثال: "dxxxxxxxx"
const UPLOAD_PRESET = "elwakeel"; // مثال: "ml_default" (لازم يكون Unsigned)

/* --- 1. دالة رفع الصور (Cloudinary Version) --- */
export const uploadImage = async (file) => {
  if (!file) return null;

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", UPLOAD_PRESET);

  try {
    const response = await fetch(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      throw new Error("فشل رفع الصورة");
    }

    const data = await response.json();
    return data.secure_url; // بيرجع رابط الصورة المباشر HTTPS
  } catch (e) {
    console.error("Cloudinary Upload Error:", e);
    return null;
  }
};

/* --- باقي الملف زي ما هو بالظبط (Firestore) --- */

/* --- 2. قسم الحجوزات (Booking) --- */
export const getBookings = async () => {
  try {
    const q = query(collection(db, "bookings"), orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (e) {
    return [];
  }
};

export const updateBookingStatus = async (id, status) => {
  try {
    await updateDoc(doc(db, "bookings", id), { status });
    return { success: true };
  } catch (e) {
    return { success: false, error: e };
  }
};

export const deleteBooking = async (id) => {
  if (!window.confirm("حذف الحجز نهائياً؟")) return { success: false };
  try {
    await deleteDoc(doc(db, "bookings", id));
    return { success: true };
  } catch (e) {
    return { success: false };
  }
};

/* --- 3. قسم من نحن (About) --- */
export const getAboutData = async () => {
  try {
    const docSnap = await getDoc(doc(db, "siteContent", "aboutInfo"));
    return docSnap.exists() ? docSnap.data() : null;
  } catch (e) {
    return null;
  }
};

export const saveAboutData = async (data) => {
  try {
    await setDoc(doc(db, "siteContent", "aboutInfo"), data, { merge: true });
    return { success: true };
  } catch (e) {
    return { success: false };
  }
};

/* --- 4. قسم الخدمات (Services) --- */
export const getServices = async () => {
  try {
    const q = query(collection(db, "services"), orderBy("createdAt", "asc"));
    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (e) {
    return [];
  }
};

export const addService = async (data) => {
  try {
    await addDoc(collection(db, "services"), {
      ...data,
      createdAt: serverTimestamp(),
    });
    return { success: true };
  } catch (e) {
    return { success: false };
  }
};

export const updateService = async (id, data) => {
  try {
    await updateDoc(doc(db, "services", id), data);
    return { success: true };
  } catch (e) {
    return { success: false };
  }
};

export const deleteService = async (id) => {
  if (!window.confirm("حذف الخدمة؟")) return { success: false };
  try {
    await deleteDoc(doc(db, "services", id));
    return { success: true };
  } catch (e) {
    return { success: false };
  }
};

/* --- 5. قسم الفريق (Team) --- */
export const getTeamMembers = async () => {
  try {
    const q = query(collection(db, "team"), orderBy("createdAt", "asc"));
    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (e) {
    return [];
  }
};

export const addTeamMember = async (data) => {
  try {
    await addDoc(collection(db, "team"), {
      ...data,
      createdAt: serverTimestamp(),
    });
    return { success: true };
  } catch (e) {
    return { success: false };
  }
};

export const updateTeamMember = async (id, data) => {
  try {
    await updateDoc(doc(db, "team", id), data);
    return { success: true };
  } catch (e) {
    return { success: false };
  }
};

export const deleteTeamMember = async (id) => {
  if (!window.confirm("حذف العضو؟")) return { success: false };
  try {
    await deleteDoc(doc(db, "team", id));
    return { success: true };
  } catch (e) {
    return { success: false };
  }
};

/* --- 6. قسم المكتبة (Library/Blog) --- */
export const getArticles = async () => {
  try {
    const q = query(collection(db, "articles"), orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (e) {
    return [];
  }
};

export const addArticle = async (data) => {
  try {
    await addDoc(collection(db, "articles"), {
      ...data,
      createdAt: new Date().toISOString(),
    });
    return { success: true };
  } catch (e) {
    return { success: false };
  }
};

export const updateArticle = async (id, data) => {
  try {
    await updateDoc(doc(db, "articles", id), data);
    return { success: true };
  } catch (e) {
    return { success: false };
  }
};
export const getArticleById = async (id) => {
  try {
    const docRef = doc(db, "articles", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      return null;
    }
  } catch (e) {
    console.error("Error fetching article:", e);
    return null;
  }
};

export const deleteArticle = async (id) => {
  if (!window.confirm("حذف المقال؟")) return { success: false };
  try {
    await deleteDoc(doc(db, "articles", id));
    return { success: true };
  } catch (e) {
    return { success: false };
  }
};
